import CantileverButton from 'components/CantileverButton'
import { Moon, Pencil, Ticket } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { GeckoSiteObservation } from 'types'

const FooterContent = styled.div<{ hasAuthor: boolean }>`
  display: flex;
  justify-content: ${({ hasAuthor }) =>
    hasAuthor ? 'space-between' : 'flex-end'};
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 32px;
`

const DepartmentText = styled.div`
  font-size: 10px;
  color: #aaa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
`

const ThinButton = styled(CantileverButton)`
  > div:last-child {
    font-weight: 400 !important;
    font-size: 12px !important;
  }

  transition: all 0.15s ease-in-out;

  &:hover {
    transform: scale(1.02);
    filter: brightness(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.98);
    filter: brightness(0.9);
    transition: all 0.05s ease-in-out;
  }
`

interface TooltipFooterProps {
  observation: GeckoSiteObservation
  onIgnore: (observation: GeckoSiteObservation) => void
  onCreateTicket: (observation: GeckoSiteObservation) => void
  onEdit: (observation: GeckoSiteObservation) => void
}

export const TooltipFooter: React.FC<TooltipFooterProps> = ({
  observation,
  onIgnore,
  onCreateTicket,
  onEdit,
}) => {
  const department = observation.data?.department

  return (
    <FooterContent hasAuthor={!!department}>
      {department && <DepartmentText>By: {department}</DepartmentText>}
      <ButtonContainer>
        <ThinButton
          onClick={(e) => {
            e.stopPropagation()
            onIgnore(observation)
          }}
          style={{
            padding: '0 8px',
            height: '22px',
            minHeight: '22px',
            lineHeight: '20px',
            borderRadius: '6px',
            backgroundColor: '#B8860B',
            color: 'white',
            border: 'none',
          }}>
          <Moon size={12} style={{ marginRight: '4px' }} />
          Ignore
        </ThinButton>
        <ThinButton
          primary
          onClick={(e) => {
            e.stopPropagation()
            onCreateTicket(observation)
          }}
          style={{
            padding: '0 8px',
            height: '22px',
            minHeight: '22px',
            lineHeight: '20px',
            borderRadius: '6px',
            border: 'none',
          }}>
          <Ticket size={12} style={{ marginRight: '4px' }} />
          Create Ticket
        </ThinButton>
        <ThinButton
          onClick={(e) => {
            e.stopPropagation()
            onEdit(observation)
          }}
          style={{
            padding: '0 8px',
            height: '22px',
            minHeight: '22px',
            lineHeight: '20px',
            borderRadius: '6px',
            backgroundColor: '#6B7280',
            color: 'white',
            border: 'none',
          }}>
          <Pencil size={12} style={{ marginRight: '4px' }} />
          Edit
        </ThinButton>
      </ButtonContainer>
    </FooterContent>
  )
}
